<template>
  <v-card class="pa-2 mt-2" flat="" outlined="">
    <div class="d-flex align-center">
      <h3>Open Ended</h3>
      <v-spacer />
      <v-btn depressed icon @click="$emit('delete')">
        <v-icon dark color="grey">mdi-delete</v-icon>
      </v-btn>
      <v-btn
        class="ml-4"
        depressed
        :color="extended ? 'blue' : 'grey'"
        @click="extended = !extended"
        icon
      >
        <v-icon dark v-if="!extended">mdi-menu-open</v-icon>
        <v-icon dark v-if="extended">mdi-close</v-icon>
      </v-btn>
    </div>
    <v-card-subtitle
      class="pa-0 ma-0"
      v-bind:class="{ 'red--text': characters > 300 }"
      >{{ characters }} / 300 characters</v-card-subtitle
    >
    <v-expand-transition>
      <div v-if="extended">
        <v-text-field
          label="Question Prompt"
          suffix=""
          hint="For example, Do you think the US should allow political parties?"
          v-model="assessment.question"
          maxlength="300"
        ></v-text-field>
        <v-textarea
          autocomplete="off"
          spellcheck="true"
          name="input-7-1"
          label="Response"
          hint="For example, Thank you for your response! We will review it ASAP!"
          v-model="assessment.response"
          auto-grow
          counter=""
          maxlength="800"
          value
          rows="1"
        ></v-textarea>
        <!-- <v-text-field
          label="Response"
          hint="For example, Thank you for sharing your political views!"
        ></v-text-field> -->
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    correct: "",
    extended: false
  }),
  props: {
    assessment: {
      type: Object,
      default: () => {
        return {
          question: "",
          type: "",
          options: [],
          answer: "",
          response: ""
        };
      }
    }
  },
  computed: {
    characters() {
      try {
        let num = 0;
        if (this.assessment && this.assessment.question) {
          num = num + this.assessment.question.length;
        }
        if (Array.isArray(this.assessment.options)) {
          this.assessment.options.forEach(obj => {
            if (obj.prompt) {
              num = num + `${obj.prompt}`.length;
            }
          });
        }
        return num;
      } catch (err) {
        return Number.NaN();
      }
    }
  }
};
</script>

<style scoped>
.fixed-add {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.choices {
  margin-bottom: 40px;
}
</style>
